import { FC, useState } from "react";
import styles from "./QuestionTabHead.module.css";
import QuestionForm from "@components/Forms/QuestionForm/QuestionForm";
import { Modal } from "@components/Modal/Modal";

interface QuestionTabHeadProps {
  productId?: string;
  productName?: string;
  onQuestionSubmit?: () => void;
}

export const QuestionTabHead: FC<QuestionTabHeadProps> = ({
  productId,
  productName,
  onQuestionSubmit,
}) => {
  const [showForm, setShowForm] = useState(false);

  // Обработчик успешной отправки формы
  const handleFormSuccess = () => {
    setShowForm(false);
    if (onQuestionSubmit) {
      onQuestionSubmit();
    }
  };

  // Обработчик закрытия модального окна
  const handleModalClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <div className={styles.widgetHead}>
        <button
          className={styles.addReviewButton}
          onClick={() => setShowForm(true)}
        >
          Задать вопрос
        </button>
      </div>

      <Modal isOpen={showForm} onClose={handleModalClose}>
        <QuestionForm
          productId={productId}
          productName={productName}
          onModalClose={handleFormSuccess}
        />
      </Modal>
    </>
  );
};
